/* tslint:disable */
/* eslint-disable */
/**
 * ELEMENTS API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 2
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface ParsedSAMLIDPMetadata
 */
export interface ParsedSAMLIDPMetadata {
    /**
     * 
     * @type {string}
     * @memberof ParsedSAMLIDPMetadata
     */
    entityId: string;
    /**
     * 
     * @type {string}
     * @memberof ParsedSAMLIDPMetadata
     */
    ssoUrl: string;
    /**
     * 
     * @type {string}
     * @memberof ParsedSAMLIDPMetadata
     */
    sloUrl?: string;
    /**
     * 
     * @type {string}
     * @memberof ParsedSAMLIDPMetadata
     */
    certificate: string;
}

export function ParsedSAMLIDPMetadataFromJSON(json: any): ParsedSAMLIDPMetadata {
    return ParsedSAMLIDPMetadataFromJSONTyped(json, false);
}

export function ParsedSAMLIDPMetadataFromJSONTyped(json: any, ignoreDiscriminator: boolean): ParsedSAMLIDPMetadata {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'entityId': json['entity_id'],
        'ssoUrl': json['sso_url'],
        'sloUrl': !exists(json, 'slo_url') ? undefined : json['slo_url'],
        'certificate': json['certificate'],
    };
}

export function ParsedSAMLIDPMetadataToJSON(value?: ParsedSAMLIDPMetadata | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'entity_id': value.entityId,
        'sso_url': value.ssoUrl,
        'slo_url': value.sloUrl,
        'certificate': value.certificate,
    };
}


